import { PopupDialog } from 'components/PopupDialog';
import { useAppNavigation } from 'navigation/useAppNavigation';

export const AppError = (): JSX.Element => {
  const { navigateHome } = useAppNavigation();

  return (
    <PopupDialog
      type="Error"
      message="Don't worry. It's probably on our side. Please restart the application. If the issue continues to appear, please contact us."
      dismissAction={navigateHome}
    />
  );
};
